import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';

import { Breadcrumbs } from '../../components/Breadcrumbs';
import { Loading } from '../../components/Loading';
import {
  PATH_FOLDER_DEFAULT,
  PATH_FOLDERS_DEFAULT,
} from '../../app/constants/paths.constant';
import { useBuildPath } from '../../hooks/useBuildPath.hook';
import { useFolderContext } from '../../contexts/FolderContext/hooks/useFolderContext.hook';
import { buildDocumentTitle } from '../../utils/document-title.util';
import { PageTitle } from '../../components/PageTitle';

import { FolderTabs } from './Tabs';

export const FolderPage = () => {
  const { folderId, folder } = useFolderContext();

  const { actorId } = useParams();
  const path = useBuildPath(PATH_FOLDER_DEFAULT, { folderId, actorId });

  const beforeTitleContent = (
    <>
      <Helmet>
        <title>{buildDocumentTitle('Fiche Dossier', folder?.code)}</title>
      </Helmet>
      <Breadcrumbs
        paths={[
          {
            to: PATH_FOLDERS_DEFAULT,
            label: 'dossiers',
            key: 'folders',
          },
          {
            to: path,
            label: 'fiche',
            key: 'folder',
          },
        ]}
      />
    </>
  );

  const titleContent = <PageTitle title="Fiche Dossier" />;

  if (folder) {
    return (
      <>
        {beforeTitleContent}
        <PageTitle code={folder.code} title={folder.consolidation.title} />
        <FolderTabs />
      </>
    );
  }

  return (
    <>
      <Loading />
      {beforeTitleContent}
      {titleContent}
    </>
  );
};
